export const PROMO_AND_PRODUCT_VALIDATION = "PROMO_AND_PRODUCT_VALIDATION";
export const BUSINESS_VALIDATION = "BUSINESS_VALIDATION";
